import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import stylez from "./Customer.module.css";
import { BASE_URL } from "../../Configuration/baseUrls";
import Select from "react-select";
import axiosInstance from "../../Configuration/axiosInstance";
import { FaTrash, FaEdit, FaUsers, FaFilter, FaPrint } from "react-icons/fa";
import LoadingSpinner from "../../Components/Shared/Loader/Loader";
import SuccessDialogue from "../../Components/Shared/SuccessDialog/SuccessDialog";
import PrintPDF from "../../Components/Customers/PrintCustomers/PrintCustomers";

const Customers = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [changed, setDataChanged] = useState(false);
  const [count, setCount] = useState();
  const [loading, setLoading] = useState(true);
  const [printSelected, setPrintSelected] = useState([]);
  const [data, setData] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [customerType, setCustomerType] = useState(null);
  const [custId, setCustID] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [clearFilters, setClearFilters] = useState(false);

  const [searchCriteria, setSearchCriteria] = useState({
    customerType: null,
    custId: null,
  });

  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get(
        `customers?page=${page}&limit=${pageSize}&customer=${searchCriteria.custId}&customer_type=${searchCriteria.customerType}`
      )
      .then((response) => {
        setData(response.data.data);
        setCount(response.data.count);
        setLoading(false);
      });

    axiosInstance.get(`customers/allcustomers`).then((response) => {
      setCustomers(response.data.data);
      console.log("customer", response.data.data);
    });
  }, [page, pageSize, changed, refresh]);

  const navigate = useNavigate();
  const updateCustomer = (customer) => {
    navigate("/customers/updateCustomer", { state: customer });
  };

  const customerOptions = customers.map((customer) => ({
    value: customer._id,
    label: customer.businessName,
  }));

  const customerHandler = (selectedOption) => {
    if (selectedOption && selectedOption.value) {
      setCustID(selectedOption.value);
    } else {
      setCustID(null);
    }
  };

  const handleChecked = (e, id) => {
    const checked = e.target.checked;
    if (checked) {
      setPrintSelected((prevSelected) => [...prevSelected, id]);
    } else {
      setPrintSelected((prevSelected) =>
        prevSelected.filter((selectedId) => selectedId !== id)
      );
    }
  };

  const handleNext = () => {
    setPage((prevPage) => prevPage + 1);
  };

  const handlePrevious = () => {
    setPage((prevPage) => prevPage - 1);
  };

  const deleteCustomer = (id) => {
    axiosInstance.delete(`${BASE_URL}customers/${id}`).then((res) => {
      setOpen(true);
      setMsg(res.data.message);
      setDataChanged(!changed);
    });
  };

  const handleChange = (e) => {
    setCustomerType(e.target.value);
  };

  const filter = () => {
    setPage(1);
    if (customerType) {
      setSearchCriteria((data) => ({ ...data, customerType: customerType }));
    }
    if (custId) {
      setSearchCriteria((data) => ({ ...data, custId: custId }));
    }
    setRefresh(!refresh);
    setClearFilters(true);
  };

  const handleCheckAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    if (checked) {
      const allIds = data?.map((customer) => customer._id);
      setPrintSelected(allIds);
    } else {
      setPrintSelected([]);
    }
    console.log(printSelected);
  };

  const filterHandler = (btnAction) => {
    if (btnAction === "customerType") {
      setSearchCriteria((preValue) => ({ ...preValue, customerType: null }));
      setCustomerType(null);
    }
    if (btnAction === "customer") {
      setSearchCriteria((preValue) => ({ ...preValue, custId: null }));
      setCustID(null);
    }
    setRefresh(!refresh);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Helper function to truncate text
  const truncateText = (text, maxLength = 30) => {
    if (!text) return "N/A";
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  return (
    <div className={stylez.pageContainer}>
      <SuccessDialogue msg={msg} show={open} handleClose={handleClose} />

      {/* Header Section */}
      <div className={stylez.headerContainer}>
        <div className={stylez.titleSection}>
          <h1 className={stylez.pageTitle}>Customer Contacts</h1>
        </div>

        {/* Search and Filter Section */}
        <div className={stylez.searchContainer}>
          <div className={stylez.searchRow}>
            <div className={stylez.inputGroup}>
              <label className={stylez.inputLabel}>
                <FaUsers className={stylez.labelIcon} />
                Search by Customer Name
              </label>
              <Select
                className={stylez.reactSelect}
                classNamePrefix="react-select"
                name="Customer"
                options={customerOptions}
                onChange={customerHandler}
                placeholder="Select a customer..."
                isClearable
                isSearchable
              />
            </div>

            <div className={stylez.inputGroup}>
              <label className={stylez.inputLabel}>
                <FaFilter className={stylez.labelIcon} />
                Customer Type
              </label>
              <select
                className={stylez.selectInput}
                name="customer_type"
                onChange={handleChange}
                value={customerType || ""}
              >
                <option value="">All Types</option>
                <option value="end_user">End User</option>
                <option value="reseller">Reseller</option>
              </select>
            </div>

            <button className={stylez.searchBtn} onClick={filter}>
              <FaFilter className={stylez.buttonIcon} />
              Filter
            </button>
          </div>

          {/* Active Filters */}
          {clearFilters &&
            (searchCriteria.customerType || searchCriteria.custId) && (
              <div className={stylez.activeFilters}>
                {searchCriteria.customerType && (
                  <div className={stylez.filterChip}>
                    <span className={stylez.filterText}>
                      Type: {searchCriteria.customerType}
                    </span>
                    <button
                      className={stylez.filterRemove}
                      onClick={() => filterHandler("customerType")}
                      title="Remove filter"
                    >
                      ×
                    </button>
                  </div>
                )}
                {searchCriteria.custId && (
                  <div className={stylez.filterChip}>
                    <span className={stylez.filterText}>
                      Customer:{" "}
                      {customers
                        .filter((i) => i._id === searchCriteria.custId)
                        .map((i) => i.businessName)}
                    </span>
                    <button
                      className={stylez.filterRemove}
                      onClick={() => filterHandler("customer")}
                      title="Remove filter"
                    >
                      ×
                    </button>
                  </div>
                )}
              </div>
            )}
        </div>
      </div>

      {/* Print Section */}
      <div className={stylez.printContainer}>
        <div className={stylez.printHeader}>
          <FaPrint className={stylez.printIcon} />
          <span>Print Selected Customers ({printSelected.length})</span>
        </div>
        <PrintPDF
          data={printSelected}
          setDataChanged={setDataChanged}
          changed={changed}
          customerData={data}
        />
      </div>

      {/* Table Section */}
      <div className={stylez.tableContainer}>
        {loading ? (
          <div className={stylez.loadingContainer}>
            <LoadingSpinner />
          </div>
        ) : (
          <>
            <div className={stylez.tableWrapper}>
              <table className={stylez.customersTable}>
                <thead>
                  <tr>
                    <th className={stylez.checkboxColumn}>
                      <label className={stylez.checkboxLabel}>
                        <input
                          type="checkbox"
                          onChange={handleCheckAll}
                          checked={selectAll}
                          className={stylez.checkbox}
                        />
                        <span className={stylez.checkboxText}>Select All</span>
                      </label>
                    </th>
                    <th>Customer Name</th>
                    <th>ABN</th>
                    <th>Address</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Type</th>
                    <th>Comments</th>
                    <th className={stylez.actionColumn}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((customer) => (
                    <tr
                      key={customer._id}
                      className={`${stylez.tableRow} ${
                        customer.customer_type === "reseller"
                          ? stylez.resellerRow
                          : stylez.endUserRow
                      }`}
                    >
                      <td className={stylez.checkboxCell}>
                        <input
                          type="checkbox"
                          onChange={(e) => handleChecked(e, customer?._id)}
                          checked={printSelected.includes(customer?._id)}
                          className={stylez.checkbox}
                        />
                      </td>
                      <td className={stylez.nameCell}>
                        <div className={stylez.customerName}>
                          {customer?.businessName || "N/A"}
                        </div>
                      </td>
                      <td>{customer?.abn || "N/A"}</td>
                      <td className={stylez.addressCell}>
                        <div
                          className={stylez.truncatedText}
                          title={customer?.address}
                        >
                          {truncateText(customer?.address, 25)}
                        </div>
                      </td>
                      <td className={stylez.emailCell}>
                        <div
                          className={stylez.truncatedText}
                          title={customer?.email}
                        >
                          {truncateText(customer?.email, 20)}
                        </div>
                      </td>
                      <td>{customer?.phone || "N/A"}</td>
                      <td>
                        <span
                          className={`${stylez.typeTag} ${
                            customer?.customer_type === "reseller"
                              ? stylez.resellerTag
                              : stylez.endUserTag
                          }`}
                        >
                          {customer?.customer_type || "N/A"}
                        </span>
                      </td>
                      <td className={stylez.commentsCell}>
                        <div
                          className={stylez.truncatedText}
                          title={customer?.comments}
                        >
                          {truncateText(customer?.comments, 20)}
                        </div>
                      </td>
                      <td className={stylez.actionCell}>
                        <div className={stylez.actionButtons}>
                          <button
                            className={stylez.editBtn}
                            onClick={() => updateCustomer(customer)}
                            title="Edit customer"
                          >
                            <FaEdit />
                          </button>
                          <button
                            className={stylez.deleteBtn}
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Are you sure you want to delete this Contact?"
                                )
                              ) {
                                deleteCustomer(customer._id);
                              }
                            }}
                            title="Delete customer"
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className={stylez.paginationContainer}>
              <div className={stylez.paginationInfo}>
                Showing {Math.min(pageSize, count)} of {count} customers
              </div>
              <div className={stylez.paginationControls}>
                <button
                  disabled={page === 1}
                  onClick={handlePrevious}
                  className={`${stylez.pageButton} ${
                    page === 1 ? stylez.disabled : ""
                  }`}
                >
                  Previous
                </button>
                <span className={stylez.pageInfo}>
                  Page <strong>{page}</strong>
                </span>
                <button
                  disabled={count < pageSize}
                  onClick={handleNext}
                  className={`${stylez.pageButton} ${
                    count < pageSize ? stylez.disabled : ""
                  }`}
                >
                  Next
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Customers;
